import classNames from "classnames";
import React, { ReactElement, useRef, useState } from "react";

import Img from "@components/FileServer/Img";

import { useOnClickOutside } from "@lib/hooks";

type TableProps = {
  rows: ReactElement[][];
  data?: any[];
  menuItems?: (item: any, idx: number) => ReactElement;
  action?: Function;
  className?: string;
  cbtToken?: string;
};

function Table({ rows, data, menuItems, className, action }: TableProps) {
  function ContextMenu({ children, idx }) {
    const ref = useRef();
    const [isOpen, setIsOpen] = useState(false);
    useOnClickOutside(ref, () => setIsOpen(false));

    return (
      <td ref={ref} className="profile-table__menu-cell">
        <button
          type="button"
          className="profile-table__menu-btn"
          id={`profile-table__menu-btn-${idx}`}
          onClick={() => setIsOpen(true)}
        >
          <Img src="/static/images/menu-dots.svg" />
        </button>
        {isOpen && (
          <div
            role="menu"
            className="profile-table__menu"
            onClick={() => setIsOpen(false)}
          >
            {children}
          </div>
        )}
      </td>
    );
  }

  return (
    <table
      className={classNames(
        "profile-table",
        className,
        `profile-table-${rows[0].length}-cols`
      )}
    >
      <tbody>
        {rows.map((row, ridx) => (
          <tr className={classNames({ "no-hover": action })} key={ridx}>
            <td className="profile-table__num-col">{ridx + 1}</td>
            {row.map((col, cidx) => (
              <td
                key={cidx}
                className={classNames("profile-table__cell", {
                  "profile-table__more": cidx >= 2,
                  bold: cidx === 0,
                })}
              >
                {col}
              </td>
            ))}
            {menuItems && !action && (
              <ContextMenu idx={ridx}>
                {menuItems(data[ridx], ridx)}
              </ContextMenu>
            )}
            {action && (
              <td className="modal-action-cell" key={ridx}>
                <div
                  className="modal-action-btn"
                  onClick={() => action(data[ridx])}
                  role="button"
                >
                  <Img src="/static/chevron-right.svg" />
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Table;
